const acquisitionLabel = value => value
  ? I18n.t(`v4/equipment.acquisition_types.${value}`, { defaultValue: value })
  : '—'

export const getAssetHeaders = () => [
  {
    title: I18n.t('v4/organization_asset.table.name'),
    field: 'name'
  },
  {
    // A tela só lista equipamentos automáticos, então `kind` seria constante em
    // toda linha. O que diferencia os ativos é o `icon` — o mesmo campo que
    // define o ícone no mapa (estação, pluviômetro, sensor de solo, hidrômetro).
    title: I18n.t('v4/organization_asset.table.equipment_type'),
    field: 'icon',
    render: rowData => rowData.icon
      ? I18n.t(`enumerize.v4/equipment/automatic.icon.${rowData.icon}`, { defaultValue: rowData.icon })
      : '—'
  },
  {
    title: I18n.t('v4/organization_asset.table.identifier'),
    field: 'identifier'
  },
  {
    title: I18n.t('v4/organization_asset.table.barcode'),
    field: 'barcode'
  },
  {
    title: I18n.t('v4/organization_asset.table.acquisition_type'),
    field: 'acquisition_type',
    render: rowData => acquisitionLabel(rowData.acquisition_type)
  },
  {
    title: I18n.t('v4/organization_asset.table.booster_acquisition_type'),
    field: 'booster_acquisition_type',
    render: rowData => acquisitionLabel(rowData.booster_acquisition_type)
  },
  {
    title: I18n.t('v4/organization_asset.table.status'),
    field: 'status'
  },
  {
    title: I18n.t('v4/organization_asset.table.created_at'),
    field: 'created_at'
  }
]
